// 所有状态
const state = {
  // 域名(跳转地址)
  jumplink: {},
  // 当前登录用户
  userInfo: {},
  // 个人中心信息s
  ownerInfo: null,
  owner: false,
  // 主题图
  themeImg: '',
  loginConfig: {
    loading: true
  }
}
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js